import {inject, Injectable} from '@angular/core';
import {BaseApiService} from './base-api.service';
import {AppStore} from '../store/app.store';

export type OrderFields = Record<string, Record<string, any>>;

export interface ISubmittedOrder {
  vendor: string;
  branch: string;
  previously_submitted?: boolean;
  response?: any;
}

export interface IFailedOrder {
  vendor: string;
  branch: string;
  errors: {message?: string; [key: string]: any};
}

@Injectable({
  providedIn: 'root'
})
export class OrdersService extends BaseApiService {
  private appStore = inject(AppStore);

  submitCart(orderFields: OrderFields) {
    return this.post<ISubmittedOrder[]>(`clients/${this.appStore.client_id()}/carts/${this.appStore.cart().id}/orders`, {order_fields: orderFields});
  }
}
